// @flow
import * as React from 'react';
import HeaderHeightConsumer from 'app/common/react/components/Header/Context/ContextConsumer';
import { Sticky } from 'gestalt';

type Props = {|
  children: React.Node,
  className?: ?string,
  forwardRef?: (ref: ?HTMLDivElement) => void,
  position?: 'fixed' | 'sticky',
  style?: { zIndex?: number },
|};

const ContentHeader = ({ children, className, forwardRef, position, style = {} }: Props) => (
  <HeaderHeightConsumer>
    {(top) =>
      position === 'sticky' ? (
        <Sticky
          top={top}
          dangerouslySetZIndex={style.zIndex ? { __zIndex: style.zIndex } : undefined}
        >
          <div className={className} ref={forwardRef} style={style}>
            {children}
          </div>
        </Sticky>
      ) : (
        <div
          className={className}
          ref={forwardRef}
          style={{ top, ...(position ? { position } : {}), ...style }}
        >
          {children}
        </div>
      )
    }
  </HeaderHeightConsumer>
);

export default ContentHeader;
